import React from 'react'
import { Text } from 'pcln-design-system'
import { Cars, Pin, Flights, CityView } from 'pcln-icons'
import { GetItemPropsOptions } from 'downshift'
import { LOCATION_SEARCH_TYPE } from '@/types'
import DropdownItem from './DropdownItem'

type SearchItem = {
  isItemSelected: boolean
  index: number
  getItemProps: (options: GetItemPropsOptions<LOCATION_SEARCH_TYPE>) => any
  item: LOCATION_SEARCH_TYPE & { skipFeedbackCall?: boolean }
  gaTracking?: () => void
  isMobile: boolean
}

function SearchItem({
  isItemSelected,
  index,
  getItemProps,
  item,
  gaTracking = () => {
    // leave blank to prevent error if no tracking provided
  },
  isMobile
}: SearchItem) {
  const iconName = item.type
  const iconDesc = `${iconName}-${index}`
  const ICONS: { [key: string]: unknown } = {
    PARTNER_LOC: Cars,
    POI: Pin,
    AIRPORT: Flights,
    CITY: CityView
  }

  const Icon = ICONS[iconName] ?? Pin
  const displayText = item.itemName

  return (
    <DropdownItem
      isHighlighted={isItemSelected}
      {...getItemProps({
        item,
        index,
        onClick: () => {
          gaTracking()
        }
      })}
      isMobile={isMobile}
    >
      <Icon
        color="primary"
        mx={2}
        aria-label={iconName}
        desc={iconName}
        descId={iconDesc}
        title={iconName}
        titleId={iconDesc}
        size={24}
      />
      <Text
        textStyle="subheading5"
        py={3}
        mr={2}
        role="option"
        aria-selected={isItemSelected}
      >
        {displayText}
      </Text>
    </DropdownItem>
  )
}

export default SearchItem
